import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#button" }),
    /*#__PURE__*/_createTextVNode(" Link ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Text hyperlink ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasic = _resolveComponent("EUIBasic")
  const _component_EUIDisabled = _resolveComponent("EUIDisabled")
  const _component_EUIUnderline = _resolveComponent("EUIUnderline")
  const _component_EUIIcon = _resolveComponent("EUIIcon")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasic),
    _createVNode(_component_EUIDisabled),
    _createVNode(_component_EUIUnderline),
    _createVNode(_component_EUIIcon)
  ], 64))
}